namespace Areas.Employee.TimeEntryNote {
    "use strict";

    let employeeId: number = 0;

    $(() => { init(); });   
    
    function init() {
        const $employeeDiv = $("#EmployeeId");

        if ($employeeDiv.length) {
            employeeId = Number($employeeDiv.attr("data-employee-id"));
        }

        getTimeVerificationInfo();
    }
        
    function getTimeVerificationInfo() {
        const template = $("#TimeVerificationTemplate").html();
        const $container = $("#TimeVerificationContainer");

        if ($container.length) {
            $.get(`/Employee/TimeEntryNote/GetTimeVerificationInfo/${employeeId}?startDate=${getStartDate()}`, function(data) {
                if (data === null) {
                    $container.empty();
                    $container.append(_.template(template)({}));
                } else {

                    if (data.submittedDateTime) {
                        data.submittedDateTime = moment(data.submittedDateTime).format('MM/DD/YYYY, h:mm a');
                    }
                    if (data.supervisorApprovalDateTime) {
                        data.supervisorApprovalDateTime = moment(data.supervisorApprovalDateTime).format('MM/DD/YYYY, h:mm a');
                    }
                    $container.empty();
                    $container.append(_.template(template)(data));
                }
            });
        }
    }
 
    export function getStartDate() {
        let startDate = Areas.getQueryStringParameter(location.href, "start");

        if (Areas.isEmpty(startDate)) {
            return Areas.getPreviousSundayDate().format("YYYY-MM-DD");
        }

        return startDate;
    }

    export function calendarClick() {
        var calendarDialog = 
            new Areas.Dialogs.Calendar.CalendarDialog(calendarDialogClosing);
    }

    function calendarDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const date = Areas.getPreviousSundayFromDate(data.date);

        window.location.href = `/Employee/TimeEntryNote/Index/${employeeId}?start=${date.format("YYYY-MM-DD")}`;
    }

    export function weekClick(url: string) {
        return () => {
            window.location.href = url;
        }
    }

}